// Supabase клиент для VK Mini App
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://lhrgysrrakswjajwlnsw.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imxocmd5c3JyYWtzd2phandsbnN3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc2NjU0OTQsImV4cCI6MjA3MzI0MTQ5NH0.65aW45qp6ZwApLDJJv7G8nfvYopBkYCVfYudQxmtttI';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
